<template>
  <div id="site-selector">
    <v-select
      :items="getSites"
      item-text="name"
      item-value="id"
      dense
      outlined
      @input="changeSite"
      :value="getSites.find((site) => site.id === this.getSite.id)"/>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters('site', ['getSites', 'getSite'])
  },
  methods: {
    changeSite (siteId) {
      if (this.getSite.id !== siteId) {
        this.$router.push({
          name: this.$route.name,
          params: {
            siteId: siteId
          }
        })
      }
    }
  }
}
</script>

<style scoped>
#site-selector {
  width: 232px;
}
</style>
